import { createHash } from 'crypto'

export const getApplicantEmailHash = (email) => {
  return email ? createHash('sha256').update(email).digest('base64') : null
}
